import { render, staticRenderFns } from "./StaffCard.vue?vue&type=template&id=fb464d2a&scoped=true&"
import script from "./StaffCard.vue?vue&type=script&lang=js&"
export * from "./StaffCard.vue?vue&type=script&lang=js&"
import style0 from "./StaffCard.vue?vue&type=style&index=0&id=fb464d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb464d2a",
  null
  
)

export default component.exports